import component from './LayoutEmpty.vue'
export default component
